import { useTheme } from "@mui/material/styles";

export default function Text({ x, y, text, color }) {
  const theme = useTheme();
  const wireColor = (value) =>
    value === 1
      ? theme.palette.levels.green
      : value === 0
        ? theme.palette.levels.red
        : theme.palette.levels.black;

  return (
    <text x={x} y={y} fontSize="16" fill={wireColor(color)}>
      {text} = {color}
    </text>
  );
}
